import React from 'react';
import { C } from './Layout';
import { useStyling } from './Theme';
import CustomAvatar from './components/CustomAvatar';
import { hexToRgba, stringToColor } from './utils/themeUtils';

type GalleryCardProps = {
    itemName: string;
};

export default ({ itemName = '' }: GalleryCardProps) => {
    const { theme, isDarkMode } = useStyling();

    const itemColor = hexToRgba(stringToColor(itemName), 0.3);
    const mainColor = hexToRgba(stringToColor(itemName), 1);
    return (
        <C
            sx={{
                p: 2,
                borderRight: '1px solid',
                borderColor: theme.palette.divider,
                height: '100%',
                borderTopLeftRadius: '10px',
                borderBottomLeftRadius: '10px',
                alignContent: 'center',
                backgroundColor: itemColor
            }}
        >
            <CustomAvatar
                avatarSx={{
                    width: '40px',
                    height: '40px',
                    fontSize: 14,
                    fontWeight: 500,
                    backgroundColor: theme.palette.background.paper,
                    border: `1px solid  ${mainColor}`,
                    color: isDarkMode ? theme.palette.text.primary : mainColor
                }}
                label={itemName}
            />
        </C>
    );
};
